import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative overflow-hidden flex flex-col items-center rounded-2xl bg-brand-dark-gray px-5 py-5 ring-1 ring-white/10" }
const _hoisted_2 = { class: "relative flex flex-col w-full items-center space-y-5" }

import InAppSubscription from "@/components/InAppSubscription.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'JoinPremiumCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-brand-lime/10 to-transparent" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex flex-col items-center space-y-2 text-center" }, [
        _createElementVNode("div", { class: "text-brand-lime text-xs font-semibold tracking-[0.14em] uppercase" }, "Pineapple Premium"),
        _createElementVNode("div", { class: "text-white text-xl font-medium leading-snug" }, "Unlock the full experience"),
        _createElementVNode("div", { class: "text-brand-light-gray text-base leading-relaxed" }, " Unlimited reveals, messaging, galleries, profile views, and event hosting. ")
      ], -1)),
      _createVNode(InAppSubscription, {
        class: "w-full",
        label: "Upgrade to Pineapple Premium"
      }, {
        body: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("button", { class: "mx-auto w-full flex bg-brand-lime rounded-full px-8 h-12 font-medium text-xl text-brand-black transition-all active:scale-[0.99]" }, [
            _createElementVNode("div", { class: "flex m-auto" }, "Go Premium")
          ], -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})